// @flow
import React, { PureComponent, Suspense } from 'react';
import { Container } from 'reactstrap';
import { connect } from 'react-redux';

import { changeSidebarTheme, changeSidebarType } from 'service/appconfiguration/action';
import * as layoutConstants from 'constants/layoutConstants';

import ThemeCustomizer from '../ThemeCustomizer';

import LeftSidebar from '../LeftSidebar/index';
import Topbar from '../Topbar';
import Footer from '../Footer';
import RightSidebar from '../RightSidebar';
import { sidebarController } from 'service/sidebar/action';

import './index.scss';
import PerfectScrollbar from 'react-perfect-scrollbar';

// loading
const emptyLoading = () => <div />;
const loading = () => <div className="text-center" />;


class VerticalLayout extends PureComponent {
    constructor(props) {
        super(props);
        this.openLeftMenu = this.openLeftMenu.bind(this);
        this.state = {
            theme: 0,
            sidebarValue: props.sidebarStatus.sidebar,
        };
    }

    /**
     * Opens the left menu - mobile
     */
    openLeftMenu = () => {
        if (document.body)
        {
            if (document.body.classList.contains('sidebar-enable'))
            {
                document.body.classList.remove('sidebar-enable');
                this.props.changeSidebarType(layoutConstants.LEFT_SIDEBAR_TYPE_CONDENSED);
            } else
            {
                if (document.body.classList.contains('left-side-menu-condensed'))
                    document.body.classList.remove('left-side-menu-condensed');
                document.body.classList.add('sidebar-enable');
            }
        }
    };

    componentDidMount = () => {
        // activate the condensed sidebar if smaller devices like ipad or tablet
        if (window.innerWidth >= 768 && window.innerWidth <= 1028)
        {
            this.props.changeSidebarType(layoutConstants.LEFT_SIDEBAR_TYPE_CONDENSED);
        }
    };


    openSidebar = () => {
        document.getElementById('mySidebar').style.width = '300px';
        document.getElementById('main').style.marginLeft = '300px';
    };

    closeSidebar = () => {
        document.getElementById('mySidebar').style.width = '78px';
        document.getElementById('main').style.marginLeft = '78px';
    };

    render() {
        // get the child view which we would like to render
        const children = this.props.children || null;

        const isCondensed = this.props.layout.leftSideBarType === layoutConstants.LEFT_SIDEBAR_TYPE_CONDENSED;
        const isLight = this.props.layout.leftSideBarTheme === layoutConstants.LEFT_SIDEBAR_THEME_DEFAULT;

        return (
            <div className="app">
                <div id="wrapper">
                    <Suspense fallback={emptyLoading()}>
                        <Topbar openLeftMenuCallBack={this.openLeftMenu} {...this.props} />
                    </Suspense>
                    <>
                        <div id="mySidebar"
                            className={this.props.sidebarStatus.sidebar ? 'sidebar sidebar-light' : 'sidebar sidebar-dark'}
                            style={parseInt(localStorage.getItem('theme')) ? { background: '#262939' } : { background: 'white' }}
                            onMouseOver={() => {
                                this.openSidebar();
                            }} onMouseOut={() => {
                                this.closeSidebar();
                            }}>
                            <Suspense fallback={emptyLoading()}>
                                <LeftSidebar
                                    isCondensed={isCondensed}
                                    isLight={isLight}
                                    {...this.props}
                                    themeTop={this.state.theme}
                                />
                            </Suspense>
                        </div>
                        <div id="main"
                            className={this.props.sidebarStatus.sidebar ? 'main main-common' : 'main2 main-common'}>
                            <Container fluid>
                                <Suspense fallback={loading()}>
                                    <PerfectScrollbar>
                                        {children}
                                    </PerfectScrollbar>
                                </Suspense>
                            </Container>

                            {/* <Suspense fallback={emptyLoading()}>
                                    <Footer {...this.props} />
                                </Suspense> */}
                        </div>
                    </>

                </div>
                <Footer/>
                <Suspense fallback={emptyLoading()}>
                    <RightSidebar title="Customize" {...this.props}>
                        <ThemeCustomizer />
                    </RightSidebar>
                </Suspense>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        layout: state.appConfigurationReducer,
        sidebarStatus: state.sidebarReducer,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        sidebarController: () => {
            dispatch(sidebarController());
        },
        changeSidebarType,
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(VerticalLayout);